/**
 * Template: Customers
 * -----------------------------------------------------------------------------
 * Used to import styles for all customer templates.
 *
 */
import '~async/customers/customers.scss'
import '~async/customers/header/customers-header.scss'

import { vueReady } from '~/core/runners'

import CustomersHeader from '~/components/customers-header'
import ShowPassword from '~/components/show-password'

vueReady(() => {
  CustomersHeader().init()
  ShowPassword().init()
})
